module.exports = __webpack_public_path__ + "img/Spielen.52c1c8df.svg";